import axios from "axios";
import { useRouter } from "vue-router";
import { message } from 'ant-design-vue';
let router = useRouter();
const service = axios.create({
  baseURL: "/",
});
service.interceptors.request.use(
  function (config) {
    const token = sessionStorage.getItem("token")
    if (token) config.headers["token"] = JSON.parse(sessionStorage.getItem("token")).token
    return config
  },
  function (error) {
    router.push('/')
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  function (response) {
    if (response.data.code == 20000 || response.data.code == 10004 || response.data.code == 20001) {
      message.error(response.data.msg, 1, () => {
        sessionStorage.clear();
        location.reload();
      });
    } else {
      const res = response.data;
      // if (res.data.token) sessionStorage.setItem("token", res.data.token);
        return res;
    }
  },
  function (error) {
    return Promise.reject(error);
  }
);
export default service;